import type React from 'react';
import { useMemo } from 'react';

import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import NoResultsIcon from 'assets/icons/icn_72px_no_results.svg?react';
import StandardButton from 'components/buttons/StandardButton';
import { BodyLargeLight, H3 } from 'components/typography/Typography';

import { useStyles } from './styles';

interface FilteringNoResultsProps {
  icon?: React.ReactElement<any, any>;
  noResultsHeader?: 'noResults' | 'teams.noResultsHeader' | 'notAvailableYet' | 'leagues.createEvent.noEventsAdded';
  noResultsText?: '' | 'noResultsMessage' | 'teams.noResultsText' | 'leagues.createEvent.noEventsMsg';
  noResultsActionText?: 'teams.addPlayers';
  onAction?: () => void;
}

const defaultIcon = <NoResultsIcon />;

const FilteringNoResults: React.FC<React.PropsWithChildren<FilteringNoResultsProps>> = ({
  icon = defaultIcon,
  noResultsHeader = 'noResults',
  noResultsText = 'noResultsMessage',
  noResultsActionText,
  onAction,
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return useMemo(() => {
    return (
      <Grid
        container
        alignContent="center"
        alignItems="center"
        className={classes.container}
        direction="column"
        spacing={1}
      >
        <Grid item>{icon}</Grid>
        <Grid item>
          <H3>{t(noResultsHeader)}</H3>
        </Grid>
        <Grid item>
          <BodyLargeLight>{noResultsText ? t(noResultsText) : ''}</BodyLargeLight>
        </Grid>
        {!!noResultsActionText && onAction && (
          <Grid item>
            <StandardButton variant="primary" onClick={onAction}>
              {t(noResultsActionText)}
            </StandardButton>
          </Grid>
        )}
      </Grid>
    );
  }, [classes.container, icon, noResultsActionText, noResultsHeader, noResultsText, onAction, t]);
};

export default FilteringNoResults;
